import React from 'react';
import { Switch } from 'react-router';
import Route from '@common/components/route';
import RouteNotFound from '@common/components/route-not-found';
import { FormsContainer } from './containers/forms';
import EditFormContainer from './containers/edit-form';

require('./styles.scss');

export default () => (
  <Switch>
    <Route
      path={[
        '/admin/forms/:id/edit/screens/:screenId',
        '/admin/forms/:id/edit',
        '/admin/forms/create',
      ]}
      component={EditFormContainer}
    />
    <Route
      path={[
        '/admin/forms/filter/:filter',
        '/admin/forms',
      ]}
      component={FormsContainer}
    />

    <Route component={RouteNotFound} />
  </Switch>
);
